import { HttpErrorResponse } from '@angular/common/http';
import { createAction } from '@ngrx/store';
import { initialState } from '../../../store/reducers/auth.reducer';

import { conformInvitationFeatureKey } from './confirm-invitation.config';

const scope = `[${conformInvitationFeatureKey}]`;

export const resetState = createAction(`${scope} Reset state`, () => ({ ...initialState }));

export const fetchConfirmationSettings = createAction(`${scope} Fetch confirmation settings`, (apiUrl: string) => ({ apiUrl }));
export const fetchConfirmationSettingsSucceeded = createAction(`${scope} Fetch confirmation settings Succeeded`, (result) => ({ result }));
export const fetchConfirmationSettingsFailed = createAction(`${scope} Fetch confirmation settings failed`, (error: HttpErrorResponse) => ({ error }));


